import React from "react";
import { Box, Typography } from "@mui/material";

import Panel from "../../components/Panel";
import { tl } from "../../components/translate";
import { Employee } from "../../interfaces/User";
import useMobileScreen from "../../hooks/useMobileScreen";
import { ServiceProvider } from "../../interfaces/ServiceProvidersInterface";

interface PropTypes {
  employee: Partial<Employee> | Partial<ServiceProvider> | null;
  onClose: () => void;
}

export default function EmployeeInfoPanel({ employee, onClose }: PropTypes): React.ReactNode {
  const isMobileScreen = useMobileScreen();

  if (!employee) return <></>;

  return (
    <Panel
      onClose={() => onClose()}
      titleJsx={
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <Typography variant="h6" noWrap>
            {tl("employee.info")}
          </Typography>
        </Box>
      }
    >
      <Box
        pt={4}
        display="flex"
        flexDirection="column"
        gap="5px"
        px={`${isMobileScreen ? "16px" : "32px"}`}
      >
        <Box display="flex" alignItems="center">
          <Typography width="30%" fontWeight={600}>
            {tl("name")}
          </Typography>
          <Typography>{`${employee?.firstName} ${employee?.lastName || ""}`}</Typography>
        </Box>

        {employee?.designation && (
          <Box display="flex" alignItems="center">
            <Typography width="30%" fontWeight={600}>
              {tl("designation")}
            </Typography>
            <Typography>{employee.designation}</Typography>
          </Box>
        )}

        {employee?.phone && (
          <Box display="flex" alignItems="center">
            <Typography width="30%" fontWeight={600}>
              {tl("phone")}
            </Typography>
            <Typography>{employee.phone}</Typography>
          </Box>
        )}

        {employee?.email && (
          <Box display="flex" alignItems="center">
            <Typography width="30%" fontWeight={600}>
              {tl("email")}
            </Typography>
            <Typography>{employee.email}</Typography>
          </Box>
        )}

        {employee?.address && (
          <Box display="flex" alignItems="center">
            <Typography width="30%" fontWeight={600}>
              {tl("address")}
            </Typography>
            <Typography>{employee.address}</Typography>
          </Box>
        )}

        {employee?.city && (
          <Box display="flex" alignItems="center">
            <Typography width="30%" fontWeight={600}>
              {tl("city")}
            </Typography>
            <Typography>{employee.city}</Typography>
          </Box>
        )}

        {employee?.qualification && (
          <Box display="flex" alignItems="center">
            <Typography width="30%" fontWeight={600}>
              {tl("qualification")}
            </Typography>
            <Typography>{employee.qualification}</Typography>
          </Box>
        )}
      </Box>
    </Panel>
  );
}
